import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'isErrorColored',
})
export class IsErrorColoredPipe implements PipeTransform {
  transform(
    controlErrors: ValidationErrors | null,
    isInvalid: boolean,
    definedErrors?: ValidationErrors,
  ): boolean {
    return Object.keys((isInvalid && controlErrors) ?? {}).some(
      (key) => definedErrors?.[key],
    );
  }
}
